<template>
  <section class="quick_calculator">
    <i18n path="notSureCalculateYourNeeds" class="subtext" tag="div">
      <button type="button" @click="show = true">{{ $t('calculateNeeds') }}</button>
    </i18n>
    <transition name="fade">
      <div class="overlay" v-show="show" :class="{ reduce_opacity: reduceOpacity }">
        <div class="calculator">
          <paragraph-header size="2">{{ $t('calculateNeeds') }}:</paragraph-header>
          <div class="fields">
            <label v-for="f in fields" :key="f.name">
              <span>{{ $t(f.label) }}</span>
              <custom-selector
                v-if="f.options"
                :default="f.value"
                :options="f.options"
                :switchHover="true"
                @value-change="(val) => (f.value = val)"
              ></custom-selector>
            </label>
          </div>

          <div class="result" v-html="$t('youShouldRentXXBoxes', { amount: result })"></div>

          <button
            type="button"
            class="close"
            @mouseenter="reduceOpacity = true"
            @mouseleave="reduceOpacity = false"
            @click="show = false"
          ></button>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import ParagraphHeader from './atoms/ParagraphHeader.vue'
import CustomSelector from './CustomSelector.vue'
export default {
  components: { CustomSelector, ParagraphHeader },
  data() {
    return {
      show: false,
      reduceOpacity: false,
      fields: [
        {
          name: 'rooms',
          value: 1,
          label: 'calculator.numberOfRooms',
          options: [
            { value: 1, label: 1 },
            { value: 2, label: 2 },
            { value: 3, label: 3 },
            { value: 4, label: 4 },
            { value: 5, label: 5 },
            { value: 6, label: 6 },
            { value: 7, label: '7+' },
          ],
          note: null,
          scoring: {
            1: 20,
            1.5: 25,
            2: 30,
            2.5: 32,
            3: 34,
            3.5: 36,
            4: 38,
            4.5: 40,
            5: 43,
            5.5: 46,
            6: 48,
            6.5: 50,
            7: 52,
          },
        },
        {
          name: 'adults',
          value: 1,
          label: 'calculator.numberOfAdults',
          options: [
            { value: 1, label: 1 },
            { value: 2, label: 2 },
            { value: 3, label: 3 },
            { value: 4, label: 4 },
            { value: 5, label: 5 },
            { value: 6, label: '6+' },
          ],
          note: null,
          scoring: {
            1: 1,
            2: 1.5,
            3: 2.2,
            4: 3.2,
            5: 4.1,
            6: 5.1,
          },
        },
        {
          name: 'years',
          value: 1,
          label: 'calculator.numberOfYears',
          options: [
            { value: 1, label: 1 },
            { value: 2, label: 2 },
            { value: 3, label: 3 },
            { value: 4, label: 4 },
            { value: 5, label: 5 },
            { value: 6, label: 6 },
            { value: 7, label: 7 },
            { value: 8, label: 8 },
            { value: 9, label: 9 },
            { value: 10, label: '10+' },
          ],
          note: null,
        },
      ],
    }
  },
  computed: {
    result() {
      const roomsPoints = this.fields[0].scoring[this.fields[0].value] || 52
      const adultPoints = this.fields[1].scoring[this.fields[1].value] || 5.1
      const yearsPoints = this.fields[2].value < 10 ? +this.fields[2].value : 10
      return Math.round(roomsPoints * adultPoints + yearsPoints)
    },
  },
}
</script>

<style lang="scss" scoped>
.quick_calculator {
  @include fontStyleCopyRegular;
}

h2 {
  margin-left: 13px;
}

.subtext {
  @include fontStyleCopyRegular;
}

button {
  font-family: inherit;
  font-size: inherit;
  color: inherit;
  background: none;
  border: none;
  outline: none;
  padding: 0;
  margin: 0;

  text-decoration: underline;
  cursor: pointer;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 14;
  background: rgba(245, 242, 231, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
  &.reduce_opacity {
    background: rgba(245, 242, 231, 0.85);
  }
}

.calculator {
  position: relative;
  display: block;
  width: 90%;
  max-width: 650px;
  padding: 20px;

  .fields {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
  }

  label {
    display: block;
    margin-bottom: 10px;
    margin-right: 50px;
    overflow: hidden;

    span {
      font-size: 16px;
      padding: 0 15px 10px 15px;
      display: block;
    }

    input {
      padding: 10px 15px;
      width: 60px;
      border: 0;
      background: black;
      color: #fff;
      -moz-appearance: textfield;
      text-align: center;
      font-family: inherit;
      font-size: inherit;
      font-weight: bold;
      height: 100%;

      &::-webkit-inner-spin-button,
      &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        margin: 0;
      }
    }
  }
}

.result {
  font-size: 20px;
  margin-top: 30px;
  &::v-deep span {
    font-weight: bold;
  }
}

.close {
  $buttonWidth: 16px;
  background: #000;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  position: absolute;
  top: 15px;
  right: -5px;
  transition: transform 0.3s;

  @include mq($from: tablet) {
    top: -40px;
    right: -40px;
  }

  &:hover {
    transform: rotate(90deg);
  }

  &::after,
  &::before {
    content: '';
    position: absolute;
    top: calc(50% - 1px);
    left: calc(50% - #{$buttonWidth/2});
    width: $buttonWidth;
    height: 2px;
    background: #fff;
    transform: rotate(45deg);
  }

  &::before {
    transform: rotate(-45deg);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
